import { Reducer } from 'redux';

import { ThreadExtendedActivitySharesLoadAction } from '../../domains/threadExtendedActivityShares/actions.types';

import { ThreadExtendedActivitySharesLifecycle } from './types';

const initialState: ThreadExtendedActivitySharesLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<ThreadExtendedActivitySharesLifecycle, ThreadExtendedActivitySharesLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'THREAD_EXTENDED_ACTIVITY_SHARES.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'THREAD_EXTENDED_ACTIVITY_SHARES.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.threadExtendedActivityShares };
    case 'THREAD_EXTENDED_ACTIVITY_SHARES.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
